export default class PersonneFormWidgetCreationPlvController {
    /* @ngInject */
    constructor() {}
    $onInit() {}
    $onDestroy() {}
}
